import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class GoogleAccountClientService {
  constructor(private _http: HttpClient) {}

  disconnect(disconnectUrl: string) {
    return this._http.delete(disconnectUrl);
  }
}
